@if (scheduleCourierForm) {
    <form [formGroup]="scheduleCourierForm" class="custom-form" id="schedule-courier-order-information-form">
        <p-accordion [multiple]="true">
            <p-accordionTab id="schedule-courier-order-information-container" [selected]="true">
                <ng-template pTemplate="header">
                    <div id="custom-primer-accordion-title">
                        {{ 'dashboard.scheduleCourierPickUpDrawer.section1.title' | translate }}
                    </div>
                </ng-template>
                <!-- *courier  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-courier-dropdown"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section1.courier' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <input
                        pInputText
                        id="schedule-courier-pick-up-courier-dropdown"
                        formControlName="courier"
                        optionLabel="text"
                        optionValue="value" />
                </div>
                <!-- *order name  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-order-name-multiselect"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section1.orderNames' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <p-multiSelect
                        id="schedule-courier-pick-up-order-name-multiselect"
                        formControlName="orderNames"
                        optionLabel="compositeName"
                        display="chip"
                        ariaLabelledBy="schedule-courier-pick-up-order-name-multiselect"
                        [class.ng-dirty]="orderNames.touched && orderNames.errors?.['required']"
                        [options]="ordersList()"
                        [showClear]="true"
                        [maxSelectedLabels]="ordersList().length"
                        [placeholder]="
                            'dashboard.scheduleCourierPickUpDrawer.section1.orderNames.placeholder' | translate
                        "
                        (ngModelChange)="calculateNumberOfTubes()">
                        <ng-template let-order pTemplate="item">
                            <app-ellipsis-tooltip [paragraphId]="'order-name-' + order.id" [tooltipPosition]="'left'">
                                {{ order.compositeName }}
                            </app-ellipsis-tooltip>
                        </ng-template></p-multiSelect
                    >
                    @if (orderNames.invalid && orderNames.touched && orderNames.errors?.['required']) {
                        <p class="p-error">
                            {{ 'dashboard.scheduleCourierPickUpDrawer.section1.orderNames.required' | translate }}
                        </p>
                    }
                </div>
                <!-- *number of tubes  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-number-of-tubes-input"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section1.numberOfTubes' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <input
                        pInputText
                        id="schedule-courier-pick-up-number-of-tubes-input"
                        formControlName="numberOfTubes"
                        [placeholder]="
                            'dashboard.scheduleCourierPickUpDrawer.section1.numberOfTubes.placeholder' | translate
                        " />
                </div>
            </p-accordionTab>
            <p-accordionTab id="schedule-courier-pick-up-information-container" [selected]="true">
                <ng-template pTemplate="header">
                    <div id="custom-primer-accordion-title">
                        {{ 'dashboard.scheduleCourierPickUpDrawer.section2.title' | translate }}
                    </div>
                </ng-template>
                <!-- *first name  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-first-name-input"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section2.firstName' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <input
                        pInputText
                        id="schedule-courier-pick-up-first-name-input"
                        formControlName="firstName"
                        [placeholder]="
                            'dashboard.scheduleCourierPickUpDrawer.section2.firstName.placeholder' | translate
                        " />
                </div>
                <!-- *last name  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-last-name-input"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section2.lastName' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <input
                        pInputText
                        id="schedule-courier-pick-up-last-name-input"
                        formControlName="lastName"
                        [placeholder]="
                            'dashboard.scheduleCourierPickUpDrawer.section2.lastName.placeholder' | translate
                        " />
                </div>
                <!-- *organization  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-organization-dropdown"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section2.organization' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <input
                        pInputText
                        id="schedule-courier-pick-up-organization-dropdown"
                        formControlName="organization"
                        optionLabel="text"
                        optionValue="value" />
                </div>
                <!-- *group  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-group-dropdown"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section2.group' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <input
                        pInputText
                        id="schedule-courier-pick-up-group-dropdown"
                        formControlName="group"
                        optionLabel="text"
                        optionValue="value" />
                </div>
                <!-- *pickup location  -->
                <div class="form-field">
                    <label for="schedule-courier-pick-up-location-dropdown"
                        >{{ 'dashboard.scheduleCourierPickUpDrawer.section2.pickupLocation' | translate }}
                        <span class="p-error">*</span></label
                    >
                    <p-dropdown
                        id="schedule-courier-pick-up-location-dropdown"
                        formControlName="pickupLocation"
                        optionLabel="description"
                        [options]="locationsList()"
                        [class.ng-dirty]="pickupLocation.touched && pickupLocation.errors?.['required']"
                        [showClear]="true"
                        [placeholder]="
                            'dashboard.scheduleCourierPickUpDrawer.section2.pickupLocation.placeholder' | translate
                        ">
                        <ng-template let-location pTemplate="item">
                            <app-ellipsis-tooltip [paragraphId]="'location-description-' + location.id">
                                {{ location.description }}
                            </app-ellipsis-tooltip>
                        </ng-template>
                    </p-dropdown>
                    @if (pickupLocation.value) {
                        <small>
                            {{
                                'dashboard.scheduleCourierPickUpDrawer.section2.pickupLocation.optional'
                                    | translate
                                        : {
                                              organization: organization.value,
                                              cutoffTime: pickupLocation.value.cutOffTime,
                                          }
                            }}
                        </small>
                    }
                    @if (pickupLocation.invalid && pickupLocation.touched && pickupLocation.errors?.['required']) {
                        <p class="p-error">
                            {{ 'dashboard.scheduleCourierPickUpDrawer.section2.pickupLocation.required' | translate }}
                        </p>
                    }
                </div>
            </p-accordionTab>
        </p-accordion>
        <span class="p-error">{{ 'dashboard.scheduleCourierPickUpDrawer.info' | translate }}</span>
    </form>
}
